// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-breadcrumbs {
  pointer-events: none;
}

.graph-breadcrumbs__breadcrumb {
  pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Graph/GraphBreadcrumbs/styles.css","webpack://./services/frontend/app/components/Graph/GraphBreadcrumbs/styles.css"],"names":[],"mappings":"AADA;ECEE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".graph-breadcrumbs {\n  pointer-events: none;\n}\n\n.graph-breadcrumbs__breadcrumb {\n  pointer-events: auto;\n}\n",".graph-breadcrumbs {\n  pointer-events: none;\n}\n\n.graph-breadcrumbs__breadcrumb {\n  pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
